import type { ObjectMetadata } from '@olytic/foundation';

import { formatMonthYear, formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDateTime, createdByField, field, lastModifiedByField, lookup, type Row, show, text } from './kit';

const def = OBJECT_DEFS['resource-capacity'];
const hours = show((v) => `${formatNumber(v)}h`);

/** A month a person's capacity differs from usual. Rationale: resource-capacity.md. */
export const resourceCapacity: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Capacity month',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('app_user_name', 'Person', { link: lookup('people', 'app_user_id') }),
    field('month', 'Month', { format: show(formatMonthYear) }),
    field('hours', 'Hours', { format: hours }),
    field('usual_hours', 'Usual Hours', { format: hours }),
    field('note', 'Note', { wide: true }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['app_user_name', 'month', 'hours', 'usual_hours'] },
    { key: 'note', label: 'Note', fields: ['note'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'app_user_name', 'note'],
};
